import { render } from "./AdminLiaDocument.vue?vue&type=template&id=1458e80e&scoped=true"
import script from "./AdminLiaDocument.vue?vue&type=script&lang=js"
export * from "./AdminLiaDocument.vue?vue&type=script&lang=js"

import "./AdminLiaDocument.vue?vue&type=style&index=0&id=1458e80e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1458e80e"]])

export default __exports__